import { render, staticRenderFns } from "./TripDetail.vue?vue&type=template&id=347ac90a&"
import script from "./TripDetail.vue?vue&type=script&lang=js&"
export * from "./TripDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TripDetail.vue"
export default component.exports